import { render, staticRenderFns } from "./TimeField.vue?vue&type=template&id=6ba652de"
import script from "./TimeField.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeField.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports